import { Paper } from "@mui/material"
import styled from "styled-components"

export const NumericPanelWrap = styled(Paper)<{ color: string }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 1rem;

  label,
  h4 {
    color: ${p => p.color} !important;
  }
`

export const ScoreRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  > h4 {
    position: relative;
    z-index: 1;
    pointer-events: none;
    font-size: 2rem;
  }
`

export const LabelRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
`

export const PostTextWrap = styled.div`
  margin-left: 0.5rem;
`

export const Delta = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  font-size: 1rem;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  > span {
    font-size: 1rem;
  }
`
